import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import { type Observable } from 'rxjs';

import { TourService, type TourStep } from '../tour.service';
import { TourStepDisplayComponent } from './tour-step-display/tour-step-display.component';

@Component({
  selector: 'rcp-tour-container',
  templateUrl: './tour-container.component.html',
  styleUrls: ['./tour-container.component.scss'],
  imports: [CommonModule, TourStepDisplayComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TourContainerComponent implements OnInit {
  private tourService = inject(TourService);

  tourSteps$: Observable<TourStep[]>;

  ngOnInit() {
    this.tourSteps$ = this.tourService.watchTourSteps();
  }
}
